<template>
  <div class="default-layout">
    <Header
      v-if="siteConfig.top && siteConfig.top.isOpen === 1"
      :site-config="siteConfig"
    />
    <router-view />
    <Footer
      v-if="siteConfig.bottom && siteConfig.bottom.isOpen === 1"
      :site-config="siteConfig"
    />
    <div class="website-records">
      <div class="bottom">
        <!-- <p class="ba">
          <a href="https://beian.miit.gov.cn/" target="_blank">
            京ICP备2024050851号-2
          </a>
        </p> -->
        <p class="ba">
          <a href="https://beian.miit.gov.cn/" target="_blank">
            {{ license.icp }}
          </a>
        </p>
        <p class="ba">
          {{ license.uscc }}
        </p>
        <p class="ba">
          <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank">
            {{ license.publicSecurity }}
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/header";
import Footer from "@/components/footer";
// import { getSiteConfig } from "@/api/common";

export default {
  name: "DefaultLayout",
  components: {
    Header,
    Footer,
  },
  props: {
    siteConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    license({ siteConfig }) {
      return siteConfig.license || {};
    },
  },
  // data() {
  //   return {
  //     siteConfig: {},
  //   };
  // },
  // created() {
  //   this.getSiteConfig();
  // },
  // methods: {
  //   getSiteConfig() {
  //     getSiteConfig().then(({ data }) => {
  //       this.siteConfig = data;
  //     });
  //   },
  // },
};
</script>

<style scoped>
.website-records {
  background: #171f30;
  padding-bottom: 40px;
}

.bottom {
  width: 1178px;
  margin: 0 auto;
  font-size: 18px;
  color: #606266;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #fff;
  padding-top: 40px;
}

.ba {
  margin-left: 5px;
  margin-right: 5px;
}

.bottom a {
  color: #909399;
}
</style>
